import LoginButton from "../auth/LoginButton";
import { UnauthenticatedTemplate } from '@azure/msal-react';
import './LoginPage.css';
import TypewriterEffect from 'react-typewriter-effect';
import {useState, useEffect} from 'react';

const LoginPage = () => {
   const [cursorColor, setCursorColor] = useState('transparent');

   useEffect(() => {
      const timer = setTimeout(() => {
         setCursorColor("#000000");
      }, 4300);
      return () => clearTimeout(timer); 
   }, []);

   return (
      <UnauthenticatedTemplate>
        <header className="header" ></header>
        <div className="containerLogin">
          <TypewriterEffect
            text='Hi, schön dich zu sehen und herzlich Willkommen bei der BTB :)'
            cursorColor="#3F3D56"
            textStyle={{fontSize: "1em"}}
            typeSpeed={33}
            startDelay={1000}
            cursor="|"
            multiTextDelay={1700}
            hideCursorAfterText={true}
            deleteSpeed={20}
          />
          <TypewriterEffect
            text='Bitte logge dich ein um mit dem Onboarding zu beginnen!'
            cursorColor={cursorColor}
            textStyle={{fontSize: "1em"}}
            typeSpeed={33}
            startDelay={4800}
            cursor="|"
          />
          <LoginButton />
        </div>
      </UnauthenticatedTemplate>
   );
};

export default LoginPage;
